import { SMART_INGEST_METRICS } from 'modules/billing/constants';
import { useHightouchBillingQueryContext } from 'modules/billing/contexts/HightouchBillingQueryContext';
import { useProjectQueryContext } from 'modules/billing/contexts/ProjectQueryContext';
import {
  createBreadcrumb,
  createProjectBreakdownColumns,
  createProjectBreakdownRows,
  createSmartIngestMetrics,
  createSmartIngestOrgMetricsByName,
  queryByFn,
} from 'modules/billing/utils';
import { useLocation } from 'react-router';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';

const { productionSyncsCount, testSyncsCount } = SMART_INGEST_METRICS;
export const metricNames = [productionSyncsCount, testSyncsCount];

export const SMART_INGEST_USAGE_TEXT = {
  pageTitle: 'Smart Ingest Usage',
  searchInputId: 'smart-ingest-search',
};

export const SmartIngestProjectUsage = () => {
  const { search } = useLocation();
  const { isLoading: isLoadingQuery, projects } = useProjectQueryContext();
  const {
    isError,
    isLoading: isLoadingHightouch,
    isHightouchEnabled,
    hightouchOrg,
  } = useHightouchBillingQueryContext();

  if (!isHightouchEnabled || !hightouchOrg) {
    return <></>;
  }

  const { organization, projects: hightouchProjects = [] } = hightouchOrg;
  const metrics = createSmartIngestMetrics(hightouchProjects);
  const orgMetricsByName = createSmartIngestOrgMetricsByName(
    organization.productionSyncsCount,
    organization.testSyncsCount,
  );

  /** Format rows and columns */
  const columns = createProjectBreakdownColumns(metricNames);
  const rows = createProjectBreakdownRows({
    metricNames,
    orgMetricsByName,
    projects,
    metrics,
  });

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={createBreadcrumb(search)}
      pageTitle={SMART_INGEST_USAGE_TEXT.pageTitle}
      pageActions={<ProjectUsagePageActions hasDateSelector={false} />}
      pluralResourceName="data syncs"
      isError={isError}
      isLoading={isLoadingQuery || isLoadingHightouch}
      queryByFn={queryByFn}
    />
  );
};
